import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * GetUntrustedSourceCount
 *
 * Retrieves a list of untrusted source counts from the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const GetUntrustedSourceCount = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': '/dashboard/untrustedSourceCount',
      },
      method: 'GET',
      params: { apiKey: theApiKey, date: thePayload?.date, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/Source/api/requests/queries/GetUntrustedSourceCount.js -> GetUntrustedSourceCount()',
      false,
      error
    );

    throw error;
  }
};
